import {
    dataSource
} from "@/api/api";

export default {
    name: 'sideBar',
    created() {
        this.getData(); //获取数据
        if (localStorage.getItem("stepStatus") == "true") {
            this.auth = 'true';
        } else {
            this.auth = 'false';
        }
    },
    data() {
        return {
            auth: "",
            navList: [{
                parents: '1000',
                name: '主页',
                className: 'nav-icon1',
                pathUrl: 'home',
                children: [],
            },
                {
                    parents: '2000',
                    name: '融资管理',
                    className: 'nav-icon2',
                    pathUrl: '',
                    children: [{
                        parents: '2000',
                        parent: '20001',
                        name: '申请管理',
                        className: '',
                        pathUrl: 'applyManage',
                        children: [],
                    },
                        {
                            parents: '2000',
                            parent: '20002',
                            name: '发布融资需求',
                            className: '',
                            pathUrl: 'financingNeeds',
                            children: [],
                        },
                        {
                            parents: '2000',
                            parent: '20003',
                            // name: '我的收藏',
                            name: '我的钱筐筐',
                            className: '',
                            pathUrl: 'myCollection',
                            children: [],
                        }
                    ],
                },
                /*{
                    parents: '5000',
                    name: '预授信业务',
                    className: 'nav-icon6',
                    pathUrl: 'preBusiness',
                    children: [],
                },*/
                {
                    parents: '4000',
                    name: '企业信息',
                    className: 'nav-icon4',
                    pathUrl: '',
                    children: [{
                        parents: '4000',
                        parent: '40001',
                        name: '信息认证',
                        className: '',
                        pathUrl: 'info',
                        children: [],
                    },
                        {
                            parents: '4000',
                            parent: '40002',
                            name: '平台外融资记录',
                            className: '',
                            pathUrl: 'financingRecords',
                            children: [],
                        },
                        {
                            parents: '4000',
                            parent: '40003',
                            name: '合作伙伴',
                            className: '',
                            pathUrl: 'cooperationPartner',
                            children: [],
                        },
                        {
                            parents: '4000',
                            parent: '40004',
                            name: '账号管理',
                            className: '',
                            pathUrl: 'accountManage',
                            children: [],
                        }
                    ],
                },
                {
                    parents: '3000',
                    name: '贴息申请',
                    className: 'nav-icon7',
                    pathUrl: '',
                    children: [
                        {
                            parents: '3000',
                            parent: '30001',
                            name: '政策申报',
                            className: '',
                            pathUrl: 'applyDiscount',
                            children: [],
                        },
                        {
                            parents: '3000',
                            parent: '30002',
                            name: '我的申请',
                            className: '',
                            pathUrl: 'myApply',
                            children: [],
                        },
                    ],
                }
            ],
            navId: { //导航id-三级
                parents: '',
                parent: '',
                id: '',
            }
        }
    },
    computed: {
        phone() {
            return this.$store.state.userInfo.username
        },
        logo() {
            return this.$store.state.authInfo.logo
        }
    },
    watch: {},
    methods: {
        getData() { //获取数据
            this.navId = JSON.parse(sessionStorage.getItem('enterpriseNavId'));
        },
        changeOneNav2(item, type) { //二级导航点击
            if (type == '1') {
                this.navId.id = item.parents;
                this.navId.parents = '';
                this.navId.parent = '';
            } else if (type == '2') {
                this.navId.id = item.parent;
                this.navId.parents = item.parents;
                this.navId.parent = '';
                sessionStorage.setItem('enterpriseNavId', JSON.stringify(this.navId));
            }
        },
        changeOneNav1(item) { //一级导航点击
            if (this.navId.parents != item.parents) {
                this.navId.parents = item.parents;
                this.navId.parent = item.parent;
            } else {
                this.navId.parents = '';
                this.navId.parent = '';
            }
        },
        //企业主页 认证状态
        getAuthInfoFn() {
            this.$store.dispatch('getAuthInfo')
                .then(res => {
                    let data = res.data.data;
                    if (data.stepStatus == '3') {
                        this.auth = 'true';
                    } else {
                        this.auth = 'false';
                    }

                })
        },
    },
    mounted() {
        this.getAuthInfoFn();
    },
}
